import { render, staticRenderFns } from "./debtors_report.vue?vue&type=template&id=21d16b60"
import script from "./debtors_report.vue?vue&type=script&lang=js"
export * from "./debtors_report.vue?vue&type=script&lang=js"
import style0 from "./debtors_report.vue?vue&type=style&index=0&id=21d16b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports